"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var Link_1 = __importDefault(require("@material-ui/core/Link"));
var glink_1 = require("./glink");
exports.Link = react_1.default.forwardRef(function (props, ref) {
    var to = props.to;
    return to ? (react_1.default.createElement(Link_1.default, __assign({ ref: ref, component: glink_1.GatsbyLink, to: to }, props))) : (react_1.default.createElement(Link_1.default, __assign({ ref: ref }, props)));
});
//# sourceMappingURL=link.js.map